import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const StayInTouchPage = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-657" data-mp="1enpvuorsjwmg">
      <Header data-id="element-658" data-mp="1tddx5pzz2va6" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-659" data-mp="1tcueg72i02v3">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-660" data-mp="1of2ld9q4aapb">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-661" data-mp="1oh6ss1n85ruc">
            <Navigation data-id="element-662" data-mp="22dslky88gqhw" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8 flex items-start" data-id="element-663" data-mp="22cr5ugg9vftu">
            <iframe width="540" height="550" src="https://c20a2646.sibforms.com/serve/MUIFANMaZpdKVE-1zoKY96LtDeA0OLT9-Qw8eWB-fY5Og-tKwQKfa8FlylOjCU6WEQDlnVoaDmjrhx-bQF_9cPXh1YSzfEijkc4Wculo37Gzol3xRyq_hDn7GvWyMz3rhoo_ofayj9nybCGlOV2w8Hd9NvXpmubpvM4OXEV5lU-hRtjxdw_9BMSyLKgaUCoJl_C5l6LVf-KcNXaXdw==" frameBorder="0" scrolling="no" allowFullScreen style={{
            display: 'block',
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            maxWidth: '100%',
            backgroundColor: 'transparent',
            border: 'none'
          }} data-id="element-664" data-mp="1xga9iyyx5v5o"></iframe>
          </div>
        </div>
      </main>
    </div>;
};
export default StayInTouchPage;